
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TableComponent from "../../Comman/TableComponent";
import { usePagination } from "../../../hooks/usePagination";
import { useSearch } from "../../../context/SearchContext";
import { ArticleService } from "../../../services/articleServic";
import { toast } from "react-toastify";
import { getStatusColor, STATUS_OPTIONS } from "../../../constants/Journalconstants";
// import Pagination from "../../../Comman/Pagination";
import Pagination from "../../Comman/Pagination";

import AddJournal from "../../../Modal/Admin/addJournals";
import { Eye, PenBox ,EyeOff} from "lucide-react";
import ProjectJournalList from "../../../Modal/Admin/projectJournalList";
import AddJournalModal from "../../../Modal/Admin/Journalmodal";
import MobJournalCard from "../Admin/Article/MobJournalCard";


const filterInputClass =
  "h-10 px-3 rounded-md border border-[#d3cccc] bg-white text-sm outline-none focus:border-[#521785]";

export default function ArticlesJournalsSUBSPEC() {
  const location = useLocation();
  const { debounceSearchTerm } = useSearch();

  const { projectId, documentId } = location.state || {};

  const [journals, setJournals] = useState([]);
  const { currentPage, totalPages, goToPage, setTotalPages } = usePagination();
  const [dateFilter, setDateFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [showJournals, setShowJournals] = useState(false);
  const [sortOrder, setSortOrder] = useState("DESC");
  const [visiblePasswords, setVisiblePasswords] = useState({});
  
  const navigate=useNavigate();

  const handleViewJournal = (journal) => {
    navigate(`/journal-details/${journal.id}`);
  };

  const columns = [
    {
      label: "Journal Name",
      headerClassName: "px-4 border-b border-[#d3cccc]",
      className: "px-4",
      width: "15%",
      render: (item) =>
        item?.journal?.journalLink ? (
          <a
            href={item?.journal?.journalLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="font-medium text-blue-700 hover:text-blue-900 hover:underline"
          >
            {item?.journal?.journalName}
          </a>
        ) : (
          item?.journal?.journalName
        ),
    },
    {
      label: "Title",
      field: "title",
      width: "20%",
      headerClassName: "px-4 border-b border-[#d3cccc]",
      className: "px-4",
      render: (item) => <p className="">{item?.journal?.document?.title ?? "-"}</p>,
    },
    {
      label: "Username",
      field: "username",
      width: "15%",
      headerClassName: "px-4 border-b border-[#d3cccc]",
      className: "px-4 whitespace-normal break-words",
    },
    {
          label: "Password",
          field: "password",
          width: "15%",
          headerClassName: "px-4 border-b border-[#d3cccc]",
          className: "px-4 whitespace-normal break-words",
          render: (item) => (
            <div className="flex items-center justify-center gap-2">
              <span className="break-all">
                {visiblePasswords[item.id]
                  ? item.password || "-"
                  : item.password
                    ? "••••••••"
                    : "-"}
              </span>
    
              {item.password && (
                <button
                  type="button"
                  onClick={() =>
                    setVisiblePasswords((prev) => ({
                      ...prev,
                      [item.id]: !prev[item.id],
                    }))
                  }
                  title={visiblePasswords[item.id] ? "Hide password" : "Show password"}
                  aria-label={visiblePasswords[item.id] ? "Hide password" : "Show password"}
                  className="shrink-0 rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-[#521785]"
                >
                  {visiblePasswords[item.id] ? (
                    <EyeOff size={15} className="text-gray-600"/>
                  ) : (
                    <Eye size={15} className="text-blue-600"/>
                  )}
                </button>
              )}
            </div>
          ),
    },
    {
          label: "Status",
          headerClassName: "px-2 border-b border-[#d3cccc]",
          width: "15%",
          className: "px-2 whitespace-normal break-all",
          render: (item) => (
            <select
              value={item.status}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => handleStatusChange(item.id, e.target.value)}
              aria-label={`Status for ${item.journalName}`}
              className={`inline-flex rounded-md text-sm font-medium h-8 w-full shadow-md ${getStatusColor(item.status).text} focus:ring-blue-600 focus:ring-2 ${getStatusColor(item.status).bg}`}
            >
              {STATUS_OPTIONS.map((status) => (
                <option
                  key={status}
                  value={status}
                  className={`${getStatusColor(status).text}`}
                >
                  {status}
                </option>
              ))}
            </select>
          ),
    },
    {
      label: "Last Updated",
      field: "updatedAt",
      width: "10%",
      headerClassName: "px-4 border-b border-[#d3cccc]",
      className: "px-4 whitespace-nowrap",
      render: (row) =>
        row.updatedAt
        ? new Date(row.updatedAt).toLocaleDateString("en-IN")
        : "-",
    },
    {
      label:"View",
      headerClassName: "px-4 border-b border-[#d3cccc]",
      className: "px-4 whitespace-nowrap",
      width: "10%",
      render: (row)=>(
        <div className="flex items-center justify-center gap-2">
          <button
                type="button"
                aria-label="View"
                title="View"
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewJournal(row);
                }}
                className="p-1.5 rounded-md text-blue-600 hover:bg-[#f6eeee]"
              >
                <Eye size={22}/>
          </button>
          <button
            type="button"
            onClick={()=>openEditModal(row.id)}
            className="text-blue-600 text-sm"
          >
            <PenBox size={18}/>
          </button>
        </div>
      ),
    }
  ];

  useEffect(() => {
    if (!documentId) {
      toast.error("Document ID is required.");
      setJournals([]);
      return;
    }

    fetchJournals();
  }, [
    currentPage,
    debounceSearchTerm,
    documentId,
    projectId,
    dateFilter,statusFilter,sortOrder,
    setTotalPages,
  ]);

  const fetchJournals = async () => {
      try {
        const response = await ArticleService.getJournalArticles(
          currentPage,
          10,
          debounceSearchTerm,
          documentId,
          projectId,
          dateFilter,
          statusFilter,
          sortOrder,
        );

        if (response) {
          setJournals(response?.data || []);
          setTotalPages(response?.pagination?.totalPages || 0);
        }
      } catch (error) {
        toast.error(error?.message || "Failed to fetch journal articles.");
      }
  };
    
  useEffect(() => {
    if (currentPage !== 1) {
      goToPage(1);
    }
  }, [debounceSearchTerm,dateFilter,statusFilter,sortOrder]);

  const handleStatusChange = async (id, status) => {
    try {
      const success = await ArticleService.updateArticleStatus(id, status);

      if (success) {
        toast.success("Article status updated successfully.");
        fetchJournals();
      }
    } catch (error) {
      toast.error(
        error?.message ||
          error?.message ||
          "Failed to update article status."
      );
    }
  };

  const openAddModal = () => {
    setEditingId(null);
    setShowModal(true);
  };

   const openEditModal = (id) => {
    setEditingId(id);
    setShowModal(true);
  };

  return (
    <div className="p-3">
      <div className="mb-2">
        <button
          type="button"
          onClick={()=>navigate(-1)}
          className="text-sm hover:underline mb-1"
        >
          &larr; Back to Articles
        </button>
        <p className="text-sm text-gray-500">
          {projectId}
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h1 className="text-lg xl:text-xl font-semibold">Journals</h1>

        <div className="flex flex-wrap items-center gap-3">

          <input
            type="date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
            aria-label="Filter by last updated date"
            className={filterInputClass}
          />

          <div className="flex items-center gap-2">      
            <select
              id="articleSortOrder"
              value={sortOrder}
              onChange={(e) => {
                setSortOrder(e.target.value);
                goToPage(1);
              }}
              className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm outline-none focus:border-[#521785] focus:ring-1 focus:ring-[#521785]"
            >
              <option value="DESC">Newest First</option>
              <option value="ASC">Oldest First</option>
            </select>
          </div>

          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            aria-label="Filter by status"
            className={`${filterInputClass} w-full sm:w-56`}
          >
            <option value="">All Status</option>
            {STATUS_OPTIONS.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>

          <button
            type="button"
            onClick={openAddModal}
            className="h-10 px-3 lg:px-5 rounded-md bg-blue-600 text-white text-sm hover:bg-blue-700"
          >
            + Articles
          </button>


          <button
            type="button"
            onClick={() => setShowJournals(true)}
            className="rounded-md bg-blue-600 px-3 lg:px-4 py-2 text-white hover:bg-blue-700"
          >
            View Journals
          </button>
        </div>
      </div>

      <div className="hidden lg:block overflow-x-auto border border-[#d3cccc] rounded-md mb-4">
        <TableComponent columns={columns} data={journals} headerBg="bg-[#f6eeee]" />
      </div>

      <div className="block lg:hidden mb-4">
        {journals.length > 0 ? (
          <MobJournalCard
            journals={journals}
            onView={handleViewJournal}
            onEdit={(item) => openEditModal(item.id)}
            onStatusChange={handleStatusChange}
          />
        ) : (
          <p className="rounded-md border border-[#d3cccc] bg-white py-8 text-center text-sm text-gray-500">
            No data found
          </p>
        )}
      </div>
      
      {journals.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          goToPage={goToPage}
        />
      )}

      {showModal && (
        <AddJournalModal
          isOpen={showModal}
          onClose={() => {
            setShowModal(false);
            setEditingId(null);
          }}
          mode={editingId !== null ? "edit" : "add"}
          documentId={documentId}
          projectId={projectId}
          onSave={()=>fetchJournals()}
          articleId={editingId}
        />
      )}

       <ProjectJournalList
        projectId={projectId}
        documentId={documentId}
        isOpen={showJournals}
        onClose={() => setShowJournals(false)}
      />

    </div>
  );
}
